module.exports = __webpack_public_path__ + "static/rewards-card-lancer-kait-a903cf33adb770a3aeebf395d6743a9c.png";